import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HawkinsProvider } from '@hawkins/components';
import { getTextDirection } from 'src/utils/rtlUtils';

interface RTLProviderProps {
  children: React.ReactNode;
}

/**
 * RTL-aware Hawkins provider that automatically updates document direction based on current language
 */
export const RTLProvider: React.FC<RTLProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      const newDirection = getTextDirection(lng);
      
      // Update document direction - Hawkins components will automatically respond to this
      document.documentElement.dir = newDirection;
      document.documentElement.lang = lng;
    };

    // Set initial direction
    handleLanguageChange(i18n.language);

    // Listen for language changes
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return (
    <HawkinsProvider theme='dark'>
      {children}
    </HawkinsProvider>
  );
};